import { render, staticRenderFns } from "./ResourcePreviewCard.vue?vue&type=template&id=18ba48aa&scoped=true"
import script from "./ResourcePreviewCard.vue?vue&type=script&lang=js"
export * from "./ResourcePreviewCard.vue?vue&type=script&lang=js"
import style0 from "./ResourcePreviewCard.vue?vue&type=style&index=0&id=18ba48aa&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ba48aa",
  null
  
)

export default component.exports